

import styled from "styled-components"
import { NumericFormat } from 'react-number-format';
import { useEffect, useState } from "react";
import PhoneInput from "react-phone-input-2";
import { useDispatch } from "react-redux";
import { setFirmaValues, setYetkiliBilgileriValues, updateYetkiliValues } from "../../../../features/firma/FirmaSlice";


const Container = styled.div`
    width: ${({inputWidth}) => inputWidth};
    height: 40px;
    filter: none !important;
    background-color: ${({theme}) => theme.mainBgColor};
    position: relative;
    margin: 0 auto;

    input{
        width: 100%;
        height: 100%;
        padding: 10px 20px;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
        border: 1px solid ${({theme}) => theme.mainBorderColor};
        border-radius: ${({radius}) => radius};
        color: var(--color-dark);
        background-color: ${({theme}) => theme.mainBgColor};

        &:-webkit-autofill,
        &:-webkit-autofill:hover, 
        &:-webkit-autofill:focus, 
        &:-webkit-autofill:active{
            -webkit-box-shadow: 0 0 0 30px white inset !important;
        }
    }

    input:focus ~ label{
        color: ${({theme}) => theme.mainTextColor};
        transform: translateY(-22px);
    }

    label{
        position: absolute;
        transform: ${({value}) => value && "translateY(-22px)"};
        bottom: 10px;
        left: 20px;
        transform: translateY(-22px);
        font-size: 12px;
        font-weight: var(--font-weight-lg);
        pointer-events: none;
        transition:  all .3s ease;
        z-index: 5;
        color: ${({theme, value}) => value ? theme.mainTextColor : theme.secondaryTextColor};
        background-color: ${({theme}) => theme.mainBgColor};
    }
`

const YetkiliPhoneUpdateInput = ({data, labelText, inputWidth, keyData, name}) => {
    // const [phoneValue, setPhoneValue] = useState("");

    const dispatch = useDispatch()

    // useEffect(()=>{
    //     setPhoneValue(data)
    // },[data])

    // useEffect(() => {
    //     if (phoneValue.length > 0) {
    //       dispatch(updateYetkiliValues({ keyData , value: phoneValue }));
    //     }
    // }, [phoneValue]);

    const handleChange = (event) => {
        const term = event.target.value;
        dispatch(updateYetkiliValues({ keyData , value: term }));
    }
    
  return (
    <Container value={data} radius={"5px"} inputWidth={inputWidth}>
        <NumericFormat type="text" id={"text"} onChange={handleChange} value={data} name={name}/>
        <label htmlFor={"text"}>{labelText}</label>
    </Container>
  )
}

export default YetkiliPhoneUpdateInput